module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-light"
  }, [_c('nav', {
    staticClass: "uk-navbar-container",
    style: (_vm.config.navStyleObject),
    attrs: {
      "id": "navbar"
    }
  }, [_c('div', {
    staticClass: "uk-container"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav uk-visible@m"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'main',
        params: {}
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.refreshMain($event)
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: home"
    }
  }), _vm._v("\n              Moje wizyty\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'data',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: user"
    }
  }), _vm._v("\n              Moje dane\n            ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.menuRejestracjaLink,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: bookmark"
    }
  }), _vm._v("\n              E-rejestracja\n            ")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: phone"
    }
  }), _vm._v("\n              Kontakt z kliniką\n            ")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "uk-navbar-nav uk-hidden@m"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-right uk-flex-right uk-text-middle uk-hidden@m"
  }, [_c('span', {
    staticStyle: {
      "cursor": "help"
    },
    attrs: {
      "title": "Jeżeli nie zostanie wykonana żadna akcja w ciągu przedstawionego czasu, nastąpi automatyczne wylogowanie.",
      "uk-tooltip": "pos: bottom"
    }
  }, [_vm._v("Sesja wygaśnie za " + _vm._s(_vm.$parent.sessionValidToText))]), _vm._v(" "), _c('a', {
    staticClass: "uk-navbar-toggle",
    attrs: {
      "uk-navbar-toggle-icon": "",
      "uk-toggle": "target: #offcanvas-nav"
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "offcanvas-nav",
      "uk-offcanvas": "overlay: true"
    }
  }, [_c('div', {
    staticClass: "uk-offcanvas-bar uk-flex uk-flex-column"
  }, [_c('ul', {
    staticClass: "uk-nav uk-nav-primary "
  }, [_c('li', {
    staticClass: "uk-text-center"
  }, [_c('a', [_c('img', {
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'main',
        params: {}
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.refreshMain($event)
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: home"
    }
  }), _vm._v("\n                  Moje wizyty")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'data',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: question"
    }
  }), _vm._v("\n                  Moje dane")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact',
        params: {}
      }
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: phone"
    }
  }), _vm._v("\n                  Kontakt z kliniką")])], 1), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-divider"
  }), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-navbar-item uk-visible@m"
  }, [_c('button', {
    staticClass: "uk-button uk-button-danger",
    attrs: {
      "id": "logout_btn"
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: sign-out"
    }
  }), _vm._v("Wyloguj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "log-out",
    attrs: {
      "href": "#",
      "id": "logout_btn_small"
    }
  }, [_c('span', {
    staticClass: "uk-icon uk-margin-small-right",
    attrs: {
      "uk-icon": "icon: sign-out"
    }
  }), _vm._v("\n                  Wyloguj")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b335fa66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/navbar.vue
// module id = 274
// module chunks = 1